import {
  getAbsenceQueryParams,
  getHolidayRangeQueryParams,
  getInitialVisibleRange,
  prefetchAbsences,
  prefetchAbsenceTypes,
  prefetchActivityTypeGroups,
  prefetchGroupStats,
  prefetchHolidays,
  prefetchResourceUsers,
} from '@src/features/absence';
import Absence from '@src/pages/Absence';
import CircularProgress from '@src/shared/ui/CircularProgress';
import { Box } from '@src/shared/ui/layout';
import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/absence')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('absence.page_title', 'Absence') }],
  }),
  loader: async ({ context }) => {
    const { apiClient, auth } = context;
    const initialVisibleRange = getInitialVisibleRange();
    await Promise.all([
      prefetchResourceUsers(apiClient),
      prefetchAbsences(apiClient, getAbsenceQueryParams(initialVisibleRange)),
      prefetchAbsenceTypes(apiClient),
      prefetchHolidays(
        apiClient,
        getHolidayRangeQueryParams(initialVisibleRange),
      ),
      prefetchActivityTypeGroups(apiClient),
      ...(auth.user?.id
        ? [prefetchGroupStats(apiClient, auth.user.id, initialVisibleRange.end)]
        : []),
    ]);
  },
  pendingMs: 0,
  pendingComponent: () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <CircularProgress size={40} />
    </Box>
  ),
  component: Absence,
});
